var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.244,
    height: 15.55,
    viewBox: "0 0 7.244 15.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path6617",
    d: "M103.569,13922.98h-3.212v-7.775H98.752v-2.68h1.605v-1.608c0-2.186.906-3.486,3.481-3.486h2.144v2.681h-1.34c-1,0-1.069.374-1.069,1.072l0,1.342H106l-.284,2.68h-2.143v7.775Z",
    transform: "translate(-98.752 -13907.431)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.3c3dc5b35712aa8a0d01916f6b770afb.svg";
export { ForwardRef as ReactComponent };